import { client } from "@/shared/api/newsquawk-headlines";
import useHeadlineStore from "@/stores/NewsquawkHeadlinesStore";
import { Endpoints } from "./endpoints";
import { deleteHeadline } from "./utils";

export const useDeleteHeadline = () => {
  const { removeHeadlineById } = useHeadlineStore();

  const deleteHeadlineById = async (id: number) => {
    // Delete headline from api
    await deleteHeadline(id);

    // Remove headline from store
    removeHeadlineById(id);
  };

  return {
    deleteHeadlineById,
  };
};
